import { LoadingCards } from '@eventbrite/eds-event-card';
import { FormattedEvent } from '@eventbrite/event-renderer';
import React from 'react';
import { DiscoverEventCardProps } from '../../../../components/DiscoverEventCard';
import { BrowseEventCardStyleSwitcher } from '../../../../containers/BrowseEventCardStyleSwitcher';
import { useEnvContext } from '../../context';

type CategoryBrowsePromotedEventProps = Pick<
    DiscoverEventCardProps,
    'data-testid' | 'onClick'
> & {
    event?: DiscoverEventCardProps['event'];
    isLoading: boolean;
};

export const CategoryBrowsePromotedEvent = ({
    event,
    isLoading,
    onClick,
    'data-testid': dataTestId,
}: CategoryBrowsePromotedEventProps) => {
    const { user, env } = useEnvContext();
    const isAuthenticated = !!user?.isAuthenticated;

    if (!event && !isLoading) {
        return null;
    }

    if (isLoading) {
        return (
            <LoadingCards
                style="grid"
                dynamicWidth={true}
                cardCount={1}
                dynamicHeight={true}
            />
        );
    }

    return (
        <BrowseEventCardStyleSwitcher
            locale={env?.localeInfo.locale || 'en_US'}
            statsigLocationString="CategoryBrowse - All"
            isAuthenticated={isAuthenticated}
            event={event as FormattedEvent}
            isLazyImage={true}
            onClick={onClick}
            affCode={'ebdssbcategorybrowse'}
            data-testid={dataTestId}
        />
    );
};
